import './App.css';
import { createContext, useContext, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import de from "javascript-time-ago/locale/de";
import TimeAgo from "javascript-time-ago";
import BookingTable from './BookingTable';
import Footer from './Footer';
import { FormLabel, Link, Button } from '@mui/material';
import { Navigate } from 'react-router';

import {
  StylesProvider,
  createGenerateClassName
} from '@mui/styles';

const generateClassName = createGenerateClassName({
  seed: 'app1'
});



function App(params) {
  const [isLogout, setisLogout] = useState(false);
  useEffect(() => {
    TimeAgo.setDefaultLocale(de.locale);
    TimeAgo.addLocale(de);
  }, []);

  const logout = () => {
    const requestOptions = {
        method: "POST",
        redirect: "follow"
        };
    fetch("perform_logout", requestOptions)
    .then(r => {
      console.info("Logout");
    }).catch(e => {
      console.error("Problem mit Logout"+e);
    }).finally(() => {
      setisLogout(true);
    })
  };

  return (
    <div>
    <Box sx={{ flexGrow: 1 }} className="booking-table-container">
      {false && <FormLabel sx={{fontSize: '50px', color: 'red', position: 'absolute', top: '200px', left: 0, transform: "rotate(-30deg)"}}>Release: Samstag, 28.06.2025</FormLabel>}
      <div><h2>Earlydeskbird</h2></div>
      <div>aufgrund der kommenden Zeitumstellung wurde am 30.03. nicht gebucht</div>
      <Link href='new-booking'>ADD BOOKING</Link>
      <Button onClick={logout}>LOGOUT</Button>
      {isLogout && <Navigate replace to='/login'/>}
      <BookingTable/>
    </Box>
    <Footer/>
    </div>
  );
}

export default App;
